//# sourceMappingURL=llm_usage.mjs.map
/// <reference types="./llm_usage.d.mts" />
import * as $decrypt from "../../data_types/decrypt.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import { CustomType as $CustomType } from "../gleam.mjs";

export class LlmStepUsage extends $CustomType {
  constructor(step, model, calls, avg_input_tokens, avg_output_tokens, p50_latency_s) {
    super();
    this.step = step;
    this.model = model;
    this.calls = calls;
    this.avg_input_tokens = avg_input_tokens;
    this.avg_output_tokens = avg_output_tokens;
    this.p50_latency_s = p50_latency_s;
  }
}
export const LlmStepUsage$LlmStepUsage = (step, model, calls, avg_input_tokens, avg_output_tokens, p50_latency_s) =>
  new LlmStepUsage(step,
  model,
  calls,
  avg_input_tokens,
  avg_output_tokens,
  p50_latency_s);
export const LlmStepUsage$isLlmStepUsage = (value) =>
  value instanceof LlmStepUsage;
export const LlmStepUsage$LlmStepUsage$step = (value) => value.step;
export const LlmStepUsage$LlmStepUsage$0 = (value) => value.step;
export const LlmStepUsage$LlmStepUsage$model = (value) => value.model;
export const LlmStepUsage$LlmStepUsage$1 = (value) => value.model;
export const LlmStepUsage$LlmStepUsage$calls = (value) => value.calls;
export const LlmStepUsage$LlmStepUsage$2 = (value) => value.calls;
export const LlmStepUsage$LlmStepUsage$avg_input_tokens = (value) =>
  value.avg_input_tokens;
export const LlmStepUsage$LlmStepUsage$3 = (value) => value.avg_input_tokens;
export const LlmStepUsage$LlmStepUsage$avg_output_tokens = (value) =>
  value.avg_output_tokens;
export const LlmStepUsage$LlmStepUsage$4 = (value) => value.avg_output_tokens;
export const LlmStepUsage$LlmStepUsage$p50_latency_s = (value) =>
  value.p50_latency_s;
export const LlmStepUsage$LlmStepUsage$5 = (value) => value.p50_latency_s;

export class LlmUsage extends $CustomType {
  constructor(proposals, steps, fetched_at) {
    super();
    this.proposals = proposals;
    this.steps = steps;
    this.fetched_at = fetched_at;
  }
}
export const LlmUsage$LlmUsage = (proposals, steps, fetched_at) =>
  new LlmUsage(proposals, steps, fetched_at);
export const LlmUsage$isLlmUsage = (value) => value instanceof LlmUsage;
export const LlmUsage$LlmUsage$proposals = (value) => value.proposals;
export const LlmUsage$LlmUsage$0 = (value) => value.proposals;
export const LlmUsage$LlmUsage$steps = (value) => value.steps;
export const LlmUsage$LlmUsage$1 = (value) => value.steps;
export const LlmUsage$LlmUsage$fetched_at = (value) => value.fetched_at;
export const LlmUsage$LlmUsage$2 = (value) => value.fetched_at;

export class LlmOrgUsage extends $CustomType {
  constructor(org_id, questions, calls, input_tokens, output_tokens) {
    super();
    this.org_id = org_id;
    this.questions = questions;
    this.calls = calls;
    this.input_tokens = input_tokens;
    this.output_tokens = output_tokens;
  }
}
export const LlmOrgUsage$LlmOrgUsage = (org_id, questions, calls, input_tokens, output_tokens) =>
  new LlmOrgUsage(org_id, questions, calls, input_tokens, output_tokens);
export const LlmOrgUsage$isLlmOrgUsage = (value) =>
  value instanceof LlmOrgUsage;
export const LlmOrgUsage$LlmOrgUsage$org_id = (value) => value.org_id;
export const LlmOrgUsage$LlmOrgUsage$0 = (value) => value.org_id;
export const LlmOrgUsage$LlmOrgUsage$questions = (value) => value.questions;
export const LlmOrgUsage$LlmOrgUsage$1 = (value) => value.questions;
export const LlmOrgUsage$LlmOrgUsage$calls = (value) => value.calls;
export const LlmOrgUsage$LlmOrgUsage$2 = (value) => value.calls;
export const LlmOrgUsage$LlmOrgUsage$input_tokens = (value) =>
  value.input_tokens;
export const LlmOrgUsage$LlmOrgUsage$3 = (value) => value.input_tokens;
export const LlmOrgUsage$LlmOrgUsage$output_tokens = (value) =>
  value.output_tokens;
export const LlmOrgUsage$LlmOrgUsage$4 = (value) => value.output_tokens;

function step_usage_decoder() {
  return $decode.field(
    "step",
    $decode.string,
    (step) => {
      return $decode.field(
        "model",
        $decode.optional($decode.string),
        (model) => {
          return $decode.field(
            "calls",
            $decode.int,
            (calls) => {
              return $decode.field(
                "avg_input_tokens",
                $decode.float,
                (avg_input_tokens) => {
                  return $decode.field(
                    "avg_output_tokens",
                    $decode.float,
                    (avg_output_tokens) => {
                      return $decode.field(
                        "p50_latency_s",
                        $decode.float,
                        (p50_latency_s) => {
                          return $decode.success(
                            new LlmStepUsage(
                              step,
                              model,
                              calls,
                              avg_input_tokens,
                              avg_output_tokens,
                              p50_latency_s,
                            ),
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function usage_decoder() {
  return $decode.field(
    "proposals",
    $decode.int,
    (proposals) => {
      return $decode.field(
        "steps",
        $decode.list(step_usage_decoder()),
        (steps) => {
          return $decode.field(
            "fetched_at",
            $decrypt.timestamp(),
            (fetched_at) => {
              return $decode.success(new LlmUsage(proposals, steps, fetched_at));
            },
          );
        },
      );
    },
  );
}

export function org_usage_decoder() {
  return $decode.field(
    "org_id",
    $decode.string,
    (org_id) => {
      return $decode.field(
        "questions",
        $decode.int,
        (questions) => {
          return $decode.field(
            "calls",
            $decode.int,
            (calls) => {
              return $decode.field(
                "input_tokens",
                $decode.int,
                (input_tokens) => {
                  return $decode.field(
                    "output_tokens",
                    $decode.int,
                    (output_tokens) => {
                      return $decode.success(
                        new LlmOrgUsage(
                          org_id,
                          questions,
                          calls,
                          input_tokens,
                          output_tokens,
                        ),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
